import * as actionTypes from '../actions/actionTypes';
import { getSortOptionsForApp } from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import CustomTypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";

const INITIAL_STATE = {
    addFormState: 'closed',
    newData: null,
    customCurrentUser: null,
    // customCurrentSortOption: "created|DESC",
    customCurrentSortOption: null,
    customLastSearch: null,
    customCurrentDialog: null,
    customCurrentProject: null,
    customEmptyProjects: 0,
    customDeletedProjects: "",
    customDeletedRooms: "",
    customUpdatedProjects: null,
    customConfigClipInfoForApp: null,
    customCurrentMainFilter: null,
    customCurrentSubFilter: [],
    customUploadInfo: null,
    customUploadInfoMaster: null,
    customSearchInfo: null,
    customCurrentUploadCount: 1,
    customFullTextSearchData: null,
    customLastByFieldsData: null,
    customLastSearchType: "",
    customPopUpHidden: false,
    customGoogleSignIn: false,
    customAppData: [],
    customNewEntry: null,
    customError: null,
    customUiConfigForApp: null,
    customErrorsForApp: null,
    customReportsData: {
        openReports: false,
        searchReports: ""
    },
    customFlexAppConfig: {
        ddSortOptions: [],
        viewListItems: [],
        workflows: [],
        transcodeWorkflows: [],
        listBoxSorted: CustomTypes.SORT_DEFAULT,
    },
    customHistory: {
        showHistory: null,
        saveHistory: { history: "" }
    },
    customUlConstraints: {}
};



const catchCustomErrorsForApp = (state, action) => {
    return { ...state, customErrorsForApp: action.payload }
}
const setCustomInitialState = (state, action) => {
    return { ...state, customNewEntry: action.payload, customError: null }
}
const setDeletedProjects = (state, action) => {
    return { ...state, customDeletedProjects: action.payload }
}

const setDeletedProjectsCounter = (state, action) => {
    let counter = state.customEmptyProjects;
    counter++;
    return { ...state, customEmptyProjects: counter }
}

const setCustomUpdatedProjects = (state, action) => {
    return { ...state, customUpdatedProjects: action.payload }
}

const setDeletedRooms = (state, action) => {
    return { ...state, customDeletedRooms: action.payload }
}

const setCustomCurrentSortOptionForApp = (state, action) => {
    let sortOption = getSortOptionsForApp(action.payload, state.customConfigClipInfoForApp);
    return { ...state, customCurrentSortOption: sortOption };
}

const getCustomConfigClipInfoForApp = (state, action) => {
    return { ...state, customConfigClipInfoForApp: action.payload };
}

const getCustomUiConfigForApp = (state, action) => {
    return { ...state, customUiConfigForApp: action.payload };
}

const setCustomCurrentMainFilter = (state, action) => {
    let currentFilter = action.payload;
    return { ...state, customCurrentMainFilter: currentFilter };
}

const setCustomCurrentSubFilter = (state, action) => {
    let currentFilter = action.payload;
    return { ...state, customCurrentSubFilter: currentFilter };
}

const getInfoMsg = (state, action, isMaster = false) => {
    let infoMsg = {};
    let tmp = isMaster ? "customUploadInfoMaster" : "customUploadInfo";
    if (state[tmp]) {
        if (action.payload.clearInfo) {
            const { isLoading } = state[tmp];
            infoMsg = { "clearInfo": false, isLoading, "lastUploadCount": null };
        } else {
            infoMsg = { ...state[tmp], ...action.payload };
        }
    }
    else
        infoMsg = action.payload;

    return infoMsg;
}

const setCustomUploadInfo = (state, action) => ({ ...state, customUploadInfo: getInfoMsg(state, action) });
const setCustomUploadInfoMaster = (state, action) => ({ ...state, customUploadInfoMaster: getInfoMsg(state, action, true) });


const setCustomSearchInfo = (state, action) => {
    let infoMsg = {};
    if (state.customSearchInfo) {
        if (action.payload.clearInfo) {
            const { isSearching } = state.customSearchInfo;
            infoMsg = { "clearInfo": false, isSearching, "lastSeachCount": null };
        } else {
            infoMsg = { ...state.customSearchInfo, ...action.payload };
        }
    }
    else
        infoMsg = action.payload;

    return { ...state, customSearchInfo: infoMsg };
}

const setCustomCurrentUploadCount = (state, action) => {
    return { ...state, customCurrentUploadCount: state.customCurrentUploadCount++ };
}

const setCustomFullTextSearchData = (state, action) => {
    return { ...state, customFullTextSearchData: action.payload };
}

const setCustomLastByFieldsData = (state, action) => {
    return { ...state, customLastByFieldsData: action.payload };
}

const setCustomLastSearchType = (state, action) => {
    return { ...state, customLastSearchType: action.payload };
}

const createNewEntrySuccess = (state, action) => {
    return { ...state, customNewEntry: action.payload }
}

const createNewEntryFail = (state, action) => {
    return { ...state, customError: action.payload }
}

const setReportsData = (state, action) => {

    let newData = { ...state.customReportsData, ...action.payload }
    return { ...state, customReportsData: newData }
}


const getCustomAppData = (state, action) => {
    //const resObj = action.payload;
    // const appData = Object.keys(resObj).map(key => resObj[key].data ? resObj[key].data : resObj[key]);
    const appData = action.payload;
    let customData = { ...state.customAppData };
    let appType = action.apitype;
    customData[appType] = appData;

    return { ...state, customAppData: customData }
}

const getCustomFlexAppConfig = (state, action) => {
    let data = { ...state.customFlexAppConfig, ...action.payload };
    return { ...state, customFlexAppConfig: data }
}

const setCustomHistory = (state, action) => {
    let data = { ...state.customHistory, ...action.payload }
    return { ...state, customHistory: data };
}

const customdataReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.CUSTOM_SET_INITIAL_STATE:
            return setCustomInitialState(state, action);
        case actionTypes.CUSTOM_TOGGLE_POPUP_HIDDEN:
            return { ...state, customPopUpHidden: !state.customPopUpHidden };
        case actionTypes.CUSTOM_GOOGLE_SIGN_IN:
            return { ...state, customGoogleSignIn: action.payload };
        case actionTypes.CUSTOM_SAVE_CURRENTUSER:
            return { ...state, customCurrentUser: action.payload }
        case actionTypes.CUSTOM_SET_ADDFORM_STATE:
            return { ...state, addFormState: action.payload };
        case actionTypes.CUSTOM_SET_NEWDATA:
            return { ...state, newData: action.payload };
        case actionTypes.CUSTOM_SET_HISTORY:
            return setCustomHistory(state, action);
        case actionTypes.CUSTOM_SET_CURRENT_SORTOPTION:
            return setCustomCurrentSortOptionForApp(state, action);
        case actionTypes.CUSTOM_GET_LAST_SEARCH:
            return { ...state, customLastSearch: action.payload };
        case actionTypes.CUSTOM_SET_CURRENT_DIALOG:
            return { ...state, customCurrentDialog: action.payload };
        case actionTypes.CUSTOM_RELOAD_PROJECT:
            return { ...state, customReloading: action.payload };
        case actionTypes.CUSTOM_SET_CURRENT_PROJECT:
            return { ...state, customCurrentProject: action.payload };
        case actionTypes.CUSTOM_GET_APP_DATA_SUCCESS:
            return getCustomAppData(state, action);
        case actionTypes.CUSTOM_GET_UL_CONSTRAINTS_SUCCESS:
            return { ...state, customUlConstraints: action.payload }
        case actionTypes.CUSTOM_SET_EMPTY_PROJECTS:
            return setDeletedProjectsCounter(state, action)
        case actionTypes.CUSTOM_SET_DELETED_PROJECTS:
            return setDeletedProjects(state, action);
        case actionTypes.CUSTOM_SET_DELETED_ROOMS:
            return setDeletedRooms(state, action);
        case actionTypes.CUSTOM_SET_UPDATED_PROJECTS:
            return setCustomUpdatedProjects(state, action);
        case actionTypes.CUSTOM_GET_CONFIGCLIPINFO_FORAPP:
            return getCustomConfigClipInfoForApp(state, action);
        case actionTypes.CUSTOM_GET_UICONFIG_FORAPP:
            return getCustomUiConfigForApp(state, action);
        case actionTypes.CUSTOM_SET_CURRENT_MAIN_FILTER:
            return setCustomCurrentMainFilter(state, action);
        case actionTypes.CUSTOM_SET_CURRENT_SUB_FILTER:
            return setCustomCurrentSubFilter(state, action);
        case actionTypes.CUSTOM_SET_UPLOAD_INFO:
            return setCustomUploadInfo(state, action);
        case actionTypes.CUSTOM_SET_UPLOAD_INFO_MASTER:
            return setCustomUploadInfoMaster(state, action);
        case actionTypes.CUSTOM_SET_SEARCH_INFO:
            return setCustomSearchInfo(state, action);
        case actionTypes.CUSTOM_SET_CURRENT_UPLOAD_COUNT:
            return setCustomCurrentUploadCount(state, action);
        case actionTypes.CUSTOM_SET_FULLTEXT_SEARCH_DATA:
            return setCustomFullTextSearchData(state, action);
        case actionTypes.CUSTOM_SET_BYFIEDS_SEARCH_DATA:
            return setCustomLastByFieldsData(state, action);
        case actionTypes.CUSTOM_SET_LAST_SEARCH_TYPE:
            return setCustomLastSearchType(state, action);
        case actionTypes.CUSTOM_CREATE_NEW_ENTRY_SUCCESS:
            return createNewEntrySuccess(state, action);
        case actionTypes.CUSTOM_CREATE_NEW_ENTRY_FAIL:
            return createNewEntryFail(state, action);
        case actionTypes.CUSTOM_CATCH_APP_ERRORS:
            return catchCustomErrorsForApp(state, action);
        case actionTypes.CUSTOM_SET_REPORTS_DATA:
            return setReportsData(state, action);
        case actionTypes.CUSTOM_GET_FLEX_APP_CONFIG:
            return getCustomFlexAppConfig(state, action);
        case actionTypes.CUSTOM_SAVE_LASTCUSTOMDATA_SUCCESS:
        default:
            return state;
    }
}

export default customdataReducer;


